import {defineStore} from 'pinia'
import HomeView from '~/pages/HomeView.vue';
interface Card {
    path: string
    classes: string
}
function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}
export const useCardsStore = defineStore('cards', {
    state: () => ({
        cards: [] as Card[]
    }),
    getters: {
        cardDay(): {path: string, index: number} | undefined {
            if (this.cards.length === 0) return undefined;
            let index = getRandomInt(0, this.cards.length)
            let cardOfDay = this.cards[index]
    
            return {path: cardOfDay.path, index}
    
        }
    },
    actions: {
        mixCards() {
            this.trimClasses()
            let newArr = [...this.cards];
            for (let i = newArr.length - 1; i > 0; i--) {
                let j = Math.floor(Math.random() * (i + 1));
                [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
            }
            this.cards = newArr
            
        },
        trimClasses() {
            this.cards = this.cards.map(card => {
                return {
                    path: card.path,
                    classes: ''
                }
            })

        },
        selectedCard(path: string) {
            let ind =this.cards.findIndex(card => card.path === path)
            this.cards[ind].classes = 'selected'
        },
        hoverOver(index: number) {
            console.log('over', index)
            this.cards[index].classes = 'rotate_in'
        },
        hoverOut(index: number) {
            console.log('out', index)
            this.cards[index].classes = 'rotate_out'
        }
    }
})